<template>
  <div v-if="renderFlag" style="width: 100%">
    <component
      :formatter="formatterFn"
      :parser="parserFn"
      :is="compName"
      :renderConfig="renderConfig"
      v-model="modalValue"
      v-bind="$attrs"
      @blur="handleBlur"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, PropType, ref, nextTick } from 'vue'

const props = defineProps({
  compName: {
    type: String,
    default: () => ''
  },
  value: {
    type: [String, Array, Date, Number] as PropType<any>,
    default: ''
  },
  renderConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  fieldCode: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['changeValue', 'blur'])
const modalValue = computed({
  get() {
    return props.value
  },
  set(newVal) {
    emit('changeValue', newVal)
  }
})

// 指定输入值的格式
const formatterFn = ref<Fn>()
// 指定从格式化器输入中提取的值
const parserFn = ref<Fn>()
// 是否属于【客户名称】字段(固定型应用、预定义应用)
const isCustomerName = computed(
  () => props.fieldCode === 'realName' || props.fieldCode.startsWith('customerName_')
)

nextTick(() => {
  if (isCustomerName.value) {
    formatterFn.value = value => value.replace(/\s*/g, '')
    parserFn.value = value => value.replace(/\s*/g, '')
  }
})

const renderFlag = ref(true)
function handleRefresh(item: any) {
  renderFlag.value = false
  nextTick(() => {
    renderFlag.value = true
  })
}
function handleBlur(newVal: Recordable) {
  emit('blur', newVal)
}
defineExpose({
  handleRefresh
})
</script>
